import { useAppSelector } from "src/hooks/redux-hooks";
import { successPageMessages } from "src/constants/success-page-messages";
import SuccessCheckmark from "../success-checmark/SuccessCheckMark";
import { PopupButton } from "react-calendly";
import { FaCalendarAlt } from "react-icons/fa";



interface Divert {
  caption?:string
  imageUrl?:string
  intro?:string
  title?:string
  url?:string
  _id:string
}

interface SubmitCheck {
  divert:Divert[]
}

export const SuccessMessage = () => {
  const profile = useAppSelector((state) => state.profileData);
  const client = useAppSelector(
    (state) => state.questionnaire_data.questionnaire?.client
  );

  const submitCheck: SubmitCheck  = useAppSelector(
      (state) => state?.submitCheck?.submitCheck as SubmitCheck
  );


  return (
      <div
        style={{
          backgroundImage: `linear-gradient(
            130deg,
            #E0FFF3 60%,
            #E0FFF300
          ),
          url("/images/success-background.png")`,
        }}
        className="w-full  flex-shrink-0 rounded-xl p-12  md:bg-contain bg-cover bg-right-bottom bg-no-repeat"
        role="region"
        tabIndex={0}
      >
        {
          // show success mark
          <div className="flex w-full justify-center">
            {/*<SuccessCheckmark />*/}
            {
              Array.isArray(submitCheck?.divert) && submitCheck.divert.length > 0 ? (
                  submitCheck.divert[0]?.imageUrl ? (
                      <img
                          alt="icon"
                          className="aspect-square w-[5rem] object-contain"
                          src={submitCheck.divert[0].imageUrl}
                      />
                  ) : (
                      <FaCalendarAlt size={80} />
                  )
              ) : (
                  <SuccessCheckmark />
              )
            }
          </div>
          // )
        }
        <h1 className="sr-only">Submit Page</h1>
        <div className="text-black font-inter text-3xl font-normal leading-normal ">
          <p dangerouslySetInnerHTML={{ __html: submitCheck?.divert ? submitCheck?.divert[0].title! || successPageMessages.default.heading  : successPageMessages.default.heading }}
 className="text-center font-bold mt-3"/>
        </div>
        <div dangerouslySetInnerHTML={{__html:submitCheck?.divert ? submitCheck?.divert[0].intro! || successPageMessages.default.message : successPageMessages.default.message }} className="text-black font-inter text-xl font-normal leading-normal mt-4"/>
       
       
        <div className="text-black font-inter text-xl font-bold leading-normal mt-4 text-center">
          {submitCheck?.divert?.length > 1 &&
              'Please select an option to book an appointment'
          }
        </div>
        <div className="w-full justify-center mt-4 flex gap-x-2">
          {
            submitCheck?.divert && submitCheck?.divert?.map((item: any, index: any) => (
                <PopupButton
                    key={item._id || index}
                    styles={{
                      background: client?.branding?.primaryColor ?? "#14BDF3",
                      color: "white",
                      padding: "0.4rem 1rem",
                      borderRadius: "4px",
                      fontWeight: '500'
                    }}
                    prefill={{
                      email: profile?.profile?.emails[0]?.email ?? "",
                      firstName: profile?.profile?.name?.firstName ?? "",
                      lastName: profile?.profile?.name?.lastName ?? "",
                      name: `${profile?.profile?.name?.firstName} ${profile?.profile?.name?.lastName}`,
                    }}
                    url={item.url}
                    rootElement={document?.getElementById("root")!}
                    text={item.caption}
                />
            ))
          }
        </div>
      </div>
  );
};
